var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_3211",
    "data-name": "\\uADF8\\uB8F9 3211",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 16,
    viewBox: "0 0 28 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_3065",
    "data-name": "\\uC0AC\\uAC01\\uD615 3065",
    width: 28,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_3210",
    "data-name": "\\uADF8\\uB8F9 3210",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11380",
    "data-name": "\\uD328\\uC2A4 11380",
    d: "M105.648,0a12.514,12.514,0,0,1,7.395,2.41.551.551,0,0,0,.561.093,1.4,1.4,0,0,1,1.518.416,1.339,1.339,0,0,1,.167,1.5,1.449,1.449,0,0,1-1.4.721A1.353,1.353,0,0,1,112.673,3.5a.362.362,0,0,0-.163-.459,11.757,11.757,0,0,0-11.731-1.154A11.275,11.275,0,0,0,96.948,4.7c-.107.121-.2.155-.332.038-.08-.073-.166-.141-.252-.208-.224-.174-.226-.209-.042-.412a12.22,12.22,0,0,1,4-2.945A12.691,12.691,0,0,1,104.56.045c.363-.031.724-.028,1.088-.045",
    transform: "translate(-91.633)",
    fill: "#b41d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11381",
    "data-name": "\\uD328\\uC2A4 11381",
    d: "M8.022,145.725c-.789-.837-1.574-1.679-2.365-2.515-.43-.455-.866-.905-1.3-1.354a.158.158,0,0,1-.012-.254c.341-.4.671-.8,1.009-1.2.452-.535.908-1.067,1.357-1.6.039-.046.116-.106.074-.177s-.115-.035-.175-.035c-.671,0-1.342,0-2.012,0a.382.382,0,0,0-.32.159c-.495.609-.985,1.221-1.483,1.826a2.833,2.833,0,0,1-.466.51v-.314c0-1.154-.006-2.308,0-3.462,0-.224-.071-.287-.3-.282-.592.013-1.184.011-1.775,0-.2,0-.258.058-.257.248q.008,3.749,0,7.5c0,.2.073.246.262.243.568-.009,1.136,0,1.7,0,.357,0,.358,0,.358-.351,0-.679,0-1.358,0-2.1.178.17.313.287.434.417.657.707,1.309,1.418,1.964,2.125.346.374.7.74,1.042,1.12a.285.285,0,0,0,.235.114c.789,0,1.578,0,2.367,0,.05,0,.128.025.143-.04a.19.19,0,0,0-.059-.141c-.139-.146-.291-.281-.429-.427",
    transform: "translate(0 -130.728)",
    fill: "#2b4892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11382",
    "data-name": "\\uD328\\uC2A4 11382",
    d: "M466.137,172.773a1.636,1.636,0,0,0-.484-1.154,2.1,2.1,0,0,0-1.556-.592c-1.262-.022-2.525,0-3.788-.009-.172,0-.24.049-.235.222.01.351.018.7,0,1.054-.015.243.083.293.312.29.876-.011,1.752-.006,2.628,0a.675.675,0,0,1,.773.6,1.46,1.46,0,0,1,.034.339c0,.618,0,.611-.626.62a7.325,7.325,0,0,0-1.3.042,2.25,2.25,0,0,0-1.787,1.329,3.166,3.166,0,0,0-.129,1.664,2.393,2.393,0,0,0,2.048,1.925,7.38,7.38,0,0,0,1.641.034,1.588,1.588,0,0,0,1.135-.583.985.985,0,0,1,1.017-.361c.313.042.318.049.318-.26q0-1.284,0-2.568c0-.864.007-1.727,0-2.591m-2.188,4.166a.976.976,0,0,1-1.46.637c-.316-.178-.336-.5-.372-.8a2.336,2.336,0,0,1,.05-.727.677.677,0,0,1,.079-.188c.205-.373.568-.364.926-.345a.715.715,0,0,1,.682.406,1.3,1.3,0,0,1,.1.7,1.605,1.605,0,0,1,0,.309",
    transform: "translate(-438.142 -163.167)",
    fill: "#2b4892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11383",
    "data-name": "\\uD328\\uC2A4 11383",
    d: "M138.723,166.274a4.479,4.479,0,0,0-1.838-.255,5.408,5.408,0,0,0-1.116.088,2.81,2.81,0,0,0-1.826,1.073,3.4,3.4,0,0,0-.594,2.254,4.487,4.487,0,0,0,.126,1.061,2.71,2.71,0,0,0,1.89,2.144,6.263,6.263,0,0,0,1.445.164,7.454,7.454,0,0,0,1.243-.084,2.507,2.507,0,0,0,2.191-1.7,4.833,4.833,0,0,0,.184-2.765,2.647,2.647,0,0,0-1.705-1.98m-.5,3.977a.916.916,0,0,1-.96.854,2.068,2.068,0,0,1-.588-.015c-.623-.128-.789-.436-.869-1.107a5.634,5.634,0,0,1,0-.622c.022-.215,0-.479.034-.747a1.08,1.08,0,0,1,1.31-.886,1.114,1.114,0,0,1,1.125,1.142,4.259,4.259,0,0,1-.049,1.381",
    transform: "translate(-127.032 -158.393)",
    fill: "#2b4892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11384",
    "data-name": "\\uD328\\uC2A4 11384",
    d: "M364.036,138.579c-.5.008-1.01-.007-1.515.007-.214.006-.272-.069-.265-.265.013-.359,0-.718.006-1.077,0-.17-.059-.226-.233-.224-.6.007-1.2.011-1.8,0-.224-.005-.3.057-.3.281.011,1.047,0,2.094.005,3.141s0,2.109,0,3.164a1.492,1.492,0,0,0,1.335,1.4c.939.017,1.878,0,2.816.006.154,0,.209-.056.206-.2-.007-.336-.007-.673,0-1.009,0-.157-.053-.218-.218-.214-.363.008-.726.009-1.089,0a.662.662,0,0,1-.729-.672c-.006-.848,0-1.7,0-2.545,0-.17.06-.226.233-.224.528.007,1.057,0,1.586,0,.161,0,.226-.049.222-.211-.008-.367-.009-.734,0-1.1.005-.189-.069-.257-.263-.253",
    transform: "translate(-342.883 -130.728)",
    fill: "#2b4892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11385",
    "data-name": "\\uD328\\uC2A4 11385",
    d: "M297.3,174.257c0-.994,0-1.988,0-2.981,0-.176-.053-.242-.242-.24q-.911.014-1.823,0c-.2,0-.262.068-.261.256q.007,2.97,0,5.94c0,.185.07.235.249.233.6-.007,1.2-.011,1.8,0,.219,0,.282-.066.28-.274-.009-.978,0-1.957,0-2.936",
    transform: "translate(-281.003 -163.186)",
    fill: "#2b4892"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_11386",
    "data-name": "\\uD328\\uC2A4 11386",
    d: "M295.222,114.2c.315-.007.631,0,.947,0s.631,0,.947,0c.154,0,.208-.055.206-.2q-.008-.848,0-1.7c0-.156-.051-.217-.218-.215q-.935.01-1.87,0c-.173,0-.238.065-.237.231.006.558.007,1.116,0,1.674,0,.163.066.212.224.209",
    transform: "translate(-281.023 -106.942)",
    fill: "#2b4892"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo1);
export default __webpack_public_path__ + "static/media/footer-logo1.7ceb2141ff0e2745b9ac03e318f1127d.svg";
export { ForwardRef as ReactComponent };